/**
* 图表界面
*/
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据报表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索，切换 -->
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content">
          <div style="font-size: 24px;font-weight: 600;">{{orderdeal.todayNumber}}</div>
          <div style="font-size: 20px;font-weight: 400;">今日订单总数</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <div style="font-size: 24px;font-weight: 600;">{{orderdeal.weekNumber}}</div>
          <div style="font-size: 20px;font-weight: 400;">本周订单总数</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <div style="font-size: 24px;font-weight: 600;">{{orderdeal.monthNumber}}</div>
          <div style="font-size: 20px;font-weight: 400;">本月订单总数</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <div style="font-size: 24px;font-weight: 600;">{{orderdeal.totalUser}}</div>
          <div style="font-size: 20px;font-weight: 400;">用户总人数</div>
        </div>
      </el-col>
    </el-row>

    <!--  消息推送  -->
    <!-- 统计图 -->
    <div class="block" style="margin-top: 20px;margin-left: 30px">

    </div>
    <el-row :gutter="23">

      <el-col :span="23" class="text-c">
        <div class="st-gbox">
          <div class="cavasbox" ref="SUMEchart"></div>
        </div>
      </el-col>

    </el-row>
    <el-row></el-row>


  </div>
</template>
<script type="text/ecmascript-6">
import Chart from 'echarts'
import {
  dealCount,
  dataComparison,
  dayAmount,
  grade
} from '../../api/homeMG'
import Pagination from '../../components/Pagination'
import moment from 'moment'

export default {

  data() {
    return {
      type: 'day',
      //  销售总金额
      SUMoption: {
        // tooltip: {
        //   trigger: 'item',
        //   formatter: "{a} <br/>{b}月 : {c}"
        // },
        // legend: {
        //   data: [{
        //     name: '单量统计趋势',
        //     icon: 'rect'
        //   }],
        //   top: 1,
        //   left: 1,
        //   itemGap: 10,
        //   itemWidth: 12,
        //   itemHeight: 12,
        //   textStyle: {
        //     fontSize: 12,
        //     color: "#323232"
        //   }
        // },
        // grid: {
        //   left: 50,
        //   right: 10,
        //   top: 30,
        //   bottom: 30,
        //   borderWidth: 1
        // },
        // xAxis: {
        //   type: 'category',
        //   data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12','13'],
        //   axisLine: {
        //     lineStyle: {
        //       color: "#999999",
        //       width: 1
        //     }
        //   },
        //   axisLabel: {
        //     margin: 14,
        //     height: 70,
        //     interval: 0,
        //     textStyle: {
        //       fontSize: 10,
        //       color: "#999999"
        //     }
        //   }
        // },
        // yAxis: {
        //   type: 'value',
        //   axisLine: {
        //     lineStyle: {
        //       color: "#999999",
        //       width: 1
        //     }
        //   },
        //   axisLabel: {
        //     margin: 14,
        //     textStyle: {
        //       fontSize: 10,
        //       color: "#999999"
        //     }
        //   }
        // },
        // series: [{
        //   name: '单量统计趋势',
        //     // type: 'bar',
        //   type: 'line',
        //   barGap: 0,
        //   data: [50000, 70000, 80000, 40000, 50000, 30000, 40000, 60000, 50000, 40000, 60000, 40000,180000],
        //   barWidth: 10,
        //   itemStyle: {
        //     color: "#108ff9"
        //   }
        // }]
      },

      //订单量
      orderdeal: '',
      orderDate: '',
      //单量对比
      comparison: '',
      //时间选择
      valueTime: '',
      statisticsListX: [],
      statisticsListY: [],
      chartList: [],
      maximum: '',
      minimum: '',
      //年检车辆
      carIndex: 0,
      //消息
      ws: '',
      proTriaxialData: [],
    }
  },
  // 导入组件
  components: {
    // 点聚合组件
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.loading = true

    //订单量查看
    this.getdealCount();
    // //单量对比
    // this.getComparison();

    this.minimum = moment().subtract(30, "days").format('YYYY-MM-DD');
    this.maximum = moment().format('YYYY-MM-DD');
    //趋势图
    this.getDayAmount();



  },

  mounted() {
    console.log('aaaaaabbbbbbb')
  },


  // 里面的函数只有调用才会执行
  methods: {


    webSocket() {
      const that = this;
      this.ws = new WebSocket("wss://api.tydmsh.cn/websocket");

      // 连接成功后的回调函数
      that.ws.onopen = function (params) {
        console.log('客户端连接成功')
        // 向服务器发送消息
        that.ws.send('认证成功！')
      };
      // 从服务器接受到信息时的回调函数
      that.ws.onmessage = function (e) {
        that.proTriaxialData = [];
        that.proTriaxialData = JSON.parse(e.data);
        console.log('收到服务器响应', that.proTriaxialData)

        // console.log(that.proTriaxialData);
      };


    },


    //头部切换
    handleClick(tab, event) {
      console.log(tab, event);
      let index = tab.index;
      if (index == 0) {
        this.orderdeal = '';
        // this.orderDate = '';
        this.getdealCount();
      } else if (index == 1) {
        this.orderdeal = '';
        this.orderDate = 'yesterday';
        this.getdealCount(this.orderDate);
      } else if (index == 2) {
        this.orderdeal = '';
        this.orderDate = 'seven';
        this.getdealCount(this.orderDate);
      } else if (index == 3) {
        this.orderdeal = '';
        this.orderDate = 'thirty';
        this.getdealCount(this.orderDate);
      }
    },
    //搜索事件
    search() {
      console.log('valueTime----', this.valueTime);
      if (!this.valueTime) {
        this.$message({
          type: 'info',
          message: '请选择开始日期与结束日期！'
        })
        return
      }
      this.maximum = this.valueTime[1];
      this.minimum = this.valueTime[0];
      this.getDayAmount();
      // this.getdata(this.formInline)
    },
    // 交易总金额
    getSUM() {
      this.SUMoption = {
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}  {c}单"
        },
        legend: {
          data: [{
            name: '订单量趋势',
            icon: 'rect'
          }],
          top: 1,
          left: 1,
          itemGap: 10,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#323232"
          }
        },
        grid: {
          left: 50,
          right: 10,
          top: 30,
          bottom: 30,
          borderWidth: 1
        },
        xAxis: {
          type: 'category',
          data: this.statisticsListX,
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            height: 70,
            interval: 0,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        series: [{
          name: '订单量趋势',
          // type: 'bar',
          type: 'line',
          barGap: 0,
          data: this.statisticsListY,
          barWidth: 10,
          itemStyle: {
            color: "#108ff9"
          }
        }]
      }
      this.chart = Chart.init(this.$refs.SUMEchart)
      this.chart.setOption(this.SUMoption)
    },
    getSUM2() {
      this.SUMoption = {
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} {c}单"
        },
        legend: {
          data: [{
            name: '虚拟数据趋势',
            icon: 'rect'
          }],
          top: 1,
          left: 1,
          itemGap: 10,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#323232"
          }
        },
        grid: {
          left: 50,
          right: 10,
          top: 30,
          bottom: 30,
          borderWidth: 1
        },
        xAxis: {
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            height: 70,
            interval: 0,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        series: [{
          name: '虚拟数据趋势',
          // type: 'bar',
          type: 'line',
          barGap: 0,
          data: [50000, 70000, 80000, 40000, 50000, 30000, 40000, 60000, 50000, 40000, 60000, 40000, 180000],
          barWidth: 10,
          itemStyle: {
            color: "#108ff9"
          }
        }]
      }
      this.chart = Chart.init(this.$refs.SUMEchart)
      this.chart.setOption(this.SUMoption)
    },
    //订单量查看
    getdealCount(date) {
      this.loading = true
      if (date == undefined) {
        date = '';
      }
      // 获取用户列表
      dealCount(date).then(res => {
        this.loading = false
        console.log('单量统计---', res)
        if (res.status == 200) {
          this.orderdeal = res.data;

        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    //单量对比
    getComparison() {
      this.loading = true

      // 获取用户列表
      dataComparison().then(res => {
        this.loading = false
        console.log('comparison----res---', res)
        if (res.status == 200) {
          this.comparison = res.data;

        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    //
    getDayAmount() {
      let _self = this;
      let params = {
        maximum: this.maximum,
        minimum: this.minimum,
      }
      console.log('params----', params)

      dayAmount(params).then(res => {
        this.loading = false
        if (res.status == 200) {
          // this.comparison = res.data;
          _self.chartList = [];
          _self.statisticsListX = [];
          _self.statisticsListY = [];

          _self.chartList = res.data;
          // console.log('dataComparison----list---',list)

          if (_self.chartList == null || _self.chartList == '') {
            _self.getSUM2();

            return
          }
          _self.chartList.forEach(item => {
            _self.statisticsListX.push(item.time);
            _self.statisticsListY.push(item.number);
          })
          _self.getSUM();
        } else {
          _self.getSUM2();

          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    orderClick() {
      setTimeout(() => {
        this.logining = false
        this.$router.push('/system/vehicle')
      }, 1000)
    },
    //查看年检车辆
    getGrade() {
      grade().then(res => {
        this.loading = false
        console.log('res---', res)

        if (res.status == 200) {
          this.carIndex = res.data;
          if (this.carIndex > 0) {

          }
          // this.comparison = res.data;
          // let list =   res.data;
          // console.log('dataComparison----list---',list)


        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },

  }
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.grid-content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
    height: 100px;
    background-color: #f8f8f8;
  border-radius: 10px;
}

.text-c {
  text-align: center;
}

.st-gbox {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
  padding: 10px;
}

.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.paybox {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
  height: 32vh;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/statistics.vue